import {
  ActionResult,
  ApplicableContext,
  BaseAction,
  ExecuteContext,
} from '../framework';
import { z } from 'zod/v3';
import { ok } from 'neverthrow';
import { ModalItem } from '@cotera/client/app/components';
import { SettingsModalContent } from '../../settings';

type ModalManager = {
  push: (
    child: ModalItem & {
      onClose?: () => void;
    }
  ) => void;
};

export class OpenBillingSettings extends BaseAction<{}, { t: string }[]> {
  title = 'Billing Settings';
  description = 'Open Billing Settings';
  icon = 'banknotes';
  group = 'General';
  inputSchema = z.object({});

  constructor(private readonly modalManager: ModalManager) {
    super();
  }

  applicable(_: ApplicableContext): boolean {
    return true;
  }

  async execute(
    _: z.infer<typeof this.inputSchema>,
    _context: ExecuteContext
  ): Promise<ActionResult<{ t: string }[]>> {
    this.modalManager.push({
      view: () => <SettingsModalContent initialView="billing" />,
      size: 'lg',
    });

    return ok({ next: true });
  }
}
